<div *ngIf="!(jobcard && jobcard.ID) && summaryData && summaryData.Name">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title"><span id="jobcard">{{summaryData.JobCardNo}}</span><span
        id="customer-name">{{summaryData.Name}}</span>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span class="hubtiger-close"></span>
    </button>
  </div>
</div>

<div *ngIf="!(jobcard && jobcard.ID)">
  <app-skeleton-load-jobcard></app-skeleton-load-jobcard>
</div>

<div *ngIf="jobcard && jobcard.ID">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
    <span id="jobcard">{{jobcard.JobCardNo}}</span>
    <span id="customer-name">{{jobcard.CyclistDescription}}</span>

    <span class="additional-info highlight-black" *ngIf="jobcard.HasServicePlan">has a service plan</span>
    <span class="additional-info highlight-red" *ngIf="jobcard.CustomerGroup != '' && jobcard.CustomerGroup != null && partner.POSSystemID == 16">{{jobcard.CustomerGroup}} customer</span>
    <span id="jobstatus">{{ appConfig.getStatusLabel(jobcard.StatusID) }}</span>
  </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span class="hubtiger-close"></span>
    </button>
    <div *ngIf="cyclist.IsStravaLinked" class="strava-container">
      <div class="linked-to-strava"><img src="../../../../assets/strava-logo.png"></div>
    </div>
  </div>
  <div class="tab-container" *ngIf="!busyLinkingToNewUser">
    <div joyrideStep="jobcardStepOne" text="{{ 'bikeshop.tour.jobcard.step_one' | translate }}" (done)="tourDone()">
      <p-tabMenu [model]="getJobcardItems()" [activeItem]="activeItem" *ngIf="showMenu"></p-tabMenu>
    </div>
    <span class="fa hubtiger-print font-button float-right" pTooltip="{{
    'bikeshop.modal.update_job_card.job_card.print_this_job_card' | translate
  }}" tooltipZIndex="10000" tooltipPosition="left" (click)="printJobCard()"></span>
  </div>
  <div class="modal-body">
    <div *ngIf="!busyLinkingToNewUser">
      <div *ngIf="selectedTab===0 && dataLoaded">
        <div joyrideStep="jobcardStepTwo" text="{{ 'bikeshop.tour.jobcard.step_two' | translate }}" (done)="tourDone()">
          <app-jobcard [partnerID]="partnerID" [jobcard]="jobcard" [bike]="bike" (update)="updateJobCard($event)" [modal]="modal"
            (relinkJobCard)="linkToNewUser($event)" (completeChecklist)="completeCheckList($event)" [cyclist]="cyclist"
            [messageService]="messageService" [initialLoad]="initialLoad" (updateProject529Status)="getProject529Status()">
          </app-jobcard>
        </div>
      </div>
      <div *ngIf="selectedTab===1">
        <app-quote [partnerID]="partnerID" [jobcard]="jobcard" [messageService]="messageService"
          [jobApproved]="jobApproved"></app-quote>
      </div>
      <div *ngIf="selectedTab===2">
        <app-bike [partnerID]="partnerID" [jobcard]="jobcard" [bike]="bike" [bikeGear]="bikeGear"></app-bike>
      </div>
      <div *ngIf="selectedTab===3">
        <app-messaging [jobcard]="jobcard" [messageService]="messageService"></app-messaging>
      </div>
      <div *ngIf="selectedTab===4">
        <app-jobcard-attachments [jobcard]="jobcard" [messageService]="messageService"></app-jobcard-attachments>
      </div>
      <div *ngIf="selectedTab===5">
        <app-collections-tab [jobcard]="jobcard" [messageService]="messageService"></app-collections-tab>
      </div>
      <div *ngIf="selectedTab===6">
        <app-checklist [partnerID]="partnerID" [jobcard]="jobcard"></app-checklist>
      </div>
      <div *ngIf="selectedTab===7">
        <app-link-jobcards [partnerID]="partnerID" [jobcard]="jobcard"></app-link-jobcards>
      </div>
      <div *ngIf="selectedTab===8">
        <app-fitting-info [partnerID]="partnerID" [jobcard]="jobcard" [bike]="bike"></app-fitting-info>
      </div>
      <div *ngIf="selectedTab===9">
        <app-custom-question-responses [partnerID]="partnerID" [jobcard]="jobcard"></app-custom-question-responses>
      </div>
      <div *ngIf="selectedTab===10">
        <app-jobcard-waiver [partnerID]="partnerID" [jobcard]="jobcard"></app-jobcard-waiver>
      </div>
    </div>
    <div *ngIf="busyLinkingToNewUser">
      <app-link-new-user [partnerID]="partnerID" [jobcard]="jobcard" [cyclist]="newSearchUser"
        [messageService]="messageService" (cancel)="cancelRelink()" (relinked)="relinked($event)"></app-link-new-user>
    </div>
  </div>
</div>
<p-toast position="top-center" styleClass="hubtiger-toast"></p-toast>
